import {RegisterValues} from '@/forms/Register'
import axios from '@/utils/axios'
const Registeration = async (
  values: RegisterValues & {referral: string | null},
) => {
  const {data} = await axios.post(
    process.env.NEXT_PUBLIC_API_URL + '/register',
    values,
  )
  return data
}
const SignIn = async (data: {email: string; password: string}) => {
  await axios.post(process.env.NEXT_PUBLIC_API_URL + '/login', data)
}

const Verification = async (data: {
  verification_code: string
  country_code: string
  number: string
}) => {
  await axios.post(process.env.NEXT_PUBLIC_API_URL + '/verification', data)
}

const ResendVerificationEmail = async (phone: {
  country_code: string
  number: string
}) => {
  await axios.post(process.env.NEXT_PUBLIC_API_URL + '/resend_email', {
    country_code: phone.country_code,
    number: phone.number,
  })
}
const ResendVerification = async (phone: {
  country_code: string
  number: string
}) => {
  await axios.post(process.env.NEXT_PUBLIC_API_URL + '/resend', {
    country_code: phone.country_code,
    number: phone.number,
  })
}

const ForgotPassword = async (phone: {country_code: string; phone: string}) => {
  return await axios.post(process.env.NEXT_PUBLIC_API_URL + '/forgot', {
    country_code: phone.country_code,
    phone: phone.phone,
  })
}

const ForgotPasswordEmail = async (phone: {
  country_code: string
  phone: string
}) => {
  return await axios.post(process.env.NEXT_PUBLIC_API_URL + '/forgot_email', {
    country_code: phone.country_code,
    phone: phone.phone,
  })
}
const PasswordReset = async (data: {
  country_code: string
  phone: string
  forgot_code: string
  password: string
}) => {
  return await axios.post(process.env.NEXT_PUBLIC_API_URL + '/pass/reset', data)
}
export {
  Registeration,
  SignIn,
  Verification,
  ResendVerification,
  ResendVerificationEmail,
  ForgotPassword,
  ForgotPasswordEmail,
  PasswordReset,
}
